export default class Environment {
  static readonly BASE_API = String(import.meta.env.VITE_BASE_API)
  static readonly BASE_API_MONOLITH = String(import.meta.env.VITE_BASE_API_MONOLITH)
  static readonly CLOUD_FUNCTIONS_URL = String(
    import.meta.env.VITE_CLOUD_FUNCTIONS_URL || import.meta.env.VITE_BASE_API
  )
  static readonly FIREBASE_CONFIG = JSON.parse(String(import.meta.env.VITE_FIREBASE_CONFIG))
  static readonly LOGIN_URL = String(import.meta.env.VITE_LOGIN_URL)
  static readonly SENTRY_DSN = String(import.meta.env.VITE_SENTRY_DSN)
  static readonly PROJECT = String(import.meta.env.VITE_PROJECT)
  static readonly VITE_ENVIRONMENT = String(import.meta.env.VITE_ENVIRONMENT)
  static readonly RECAPTCHA_SITE_KEY = String(import.meta.env.VITE_RECAPTCHA_SITE_KEY || '')
}
